import React from 'react';
import { Badge as ShadcnBadge, badgeVariants } from '@/components/ui/shadcn/badge';
import { cn } from '@/lib/utils';
import { VariantProps } from 'class-variance-authority';

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {
  asChild?: boolean;
  ref?: React.Ref<HTMLSpanElement>;
}

function Badge({ className, variant, ref, ...props }: BadgeProps) {
  return (
    <ShadcnBadge
      ref={ref}
      variant={variant}
      className={cn(className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
